import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import SectionReveal from "./SectionReveal";
import WeaverLogo from "./WeaverLogo";

const Footer = ({ onContact }) => {
  return (
    <footer
      id="contact"
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/5 pt-24 sm:pt-36 pb-12"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <SectionReveal>
          <div className="text-center max-w-4xl mx-auto">
            <span className="block text-xs font-bold uppercase tracking-[0.3em] text-zinc-500 mb-6">
              05 — Get Started
            </span>
            <h2
              className="text-4xl sm:text-6xl lg:text-7xl font-black uppercase tracking-tight leading-[0.95] text-white"
              data-testid="footer-headline"
            >
              Let&apos;s make
              <br />
              <span className="text-zinc-500">something great</span>
            </h2>
          </div>
        </SectionReveal>

        <SectionReveal delay={0.15}>
          <div className="mt-14 sm:mt-20 flex flex-col items-center gap-6">
            <button
              onClick={onContact}
              data-testid="footer-make-contact-btn"
              className="group inline-flex items-center justify-center gap-3 w-full sm:w-auto px-10 py-5 bg-white text-black font-bold text-xs sm:text-sm uppercase tracking-[0.25em] hover:bg-zinc-200 transition-all duration-300"
            >
              Make Contact
              <ArrowUpRight
                size={18}
                className="transition-transform duration-500 group-hover:rotate-45"
              />
            </button>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-5 w-full sm:w-auto">
              <Link
                to="/subscription"
                data-testid="footer-explore-subscription-btn"
                className="group inline-flex items-center justify-center gap-3 w-full sm:w-auto px-10 py-5 bg-transparent border border-white/25 text-white font-bold text-xs sm:text-sm uppercase tracking-[0.25em] hover:bg-white hover:text-black transition-all duration-300"
              >
                Explore Subscription
                <ArrowUpRight
                  size={18}
                  className="transition-transform duration-500 group-hover:rotate-45"
                />
              </Link>
              <Link
                to="/pricing"
                data-testid="footer-pricing-btn"
                className="group inline-flex items-center justify-center gap-3 w-full sm:w-auto px-10 py-5 bg-transparent border border-white/25 text-white font-bold text-xs sm:text-sm uppercase tracking-[0.25em] hover:bg-white hover:text-black transition-all duration-300"
              >
                Per Project Pricing
                <ArrowUpRight
                  size={18}
                  className="transition-transform duration-500 group-hover:rotate-45"
                />
              </Link>
            </div>
          </div>
        </SectionReveal>

        {/* Large brand signoff using the official Weaver Media logo */}
        <SectionReveal delay={0.25}>
          <div
            className="mt-28 sm:mt-40 flex justify-center"
            data-testid="footer-brand-signoff"
          >
            <WeaverLogo
              variant="image"
              size="xl"
              data-testid="footer-brand-logo"
            />
          </div>
        </SectionReveal>

        <SectionReveal delay={0.35}>
          <div className="mt-10 pt-10 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-6">
            <WeaverLogo size="md" data-testid="footer-logo" />
            <p
              className="text-xs font-bold uppercase tracking-[0.25em] text-zinc-500"
              data-testid="footer-copyright"
            >
              © 2026 by Weaver Media
            </p>
            <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs font-bold uppercase tracking-[0.25em] text-zinc-500">
              <Link
                to="/subscription"
                data-testid="footer-subscription-link"
                className="text-zinc-400 hover:text-white transition-colors duration-300"
              >
                Subscription
              </Link>
              <span className="w-1 h-1 rounded-full bg-zinc-700" aria-hidden="true" />
              <Link
                to="/payment"
                data-testid="footer-client-payment-link"
                className="text-zinc-400 hover:text-white transition-colors duration-300"
              >
                Client Payment
              </Link>
              <span className="w-1 h-1 rounded-full bg-zinc-700" aria-hidden="true" />
              <span>Remote</span>
              <span className="w-1 h-1 rounded-full bg-zinc-700" aria-hidden="true" />
              <span>Worldwide</span>
            </div>
          </div>
        </SectionReveal>
      </div>
    </footer>
  );
};

export default Footer;
